import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import { AdminDelete } from "../../helpers/api_helper";
import Confirm from "../Elements/Confirm";

const AdminItem = ({
  image,
  name,
  email,
  email_verified,
  createdDate,
  updatedDate,
  query,
  detailsFetch,
  setEditId,
  setEditModal,
  adminId,
}) => {
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState(false);

  const deleteProduct = useMutation(
    (delProductId) => AdminDelete(delProductId),
    {
      onSuccess: (res) => {
        console.log(res);
        if (res.status === 200) {
          toast.success(res.message);
          queryClient.invalidateQueries(query);
          queryClient.removeQueries({
            queryKey: ["admin"],
            type: "inactive",
          });
        }
        if (res.status === 400) {
          toast.error(res.message);
        }
      },
      onError: (res) => {
        console.log(res);
      },
    }
  );

  return (
    <>
      <div className="admin-item mb-3">
        <div className="admin-item-row">
          <div className="admin-options">
            <div className="action-dropdown dropdown">
              <button
                type="button"
                className="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                <i className="fa-regular fa-fw fa-ellipsis-vertical"></i>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => {
                    setEditModal(true);
                    setEditId(adminId);
                    detailsFetch();
                  }}
                >
                  <i className="fa-regular fa-fw fa-pen-to-square"></i>Edit
                </button>
                <button
                  type="button"
                  className="dropdown-item standOut"
                  onClick={() => setDeleteModal(true)}
                >
                  <i className="fa-regular fa-fw fa-trash-can"></i>Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="admin-content">
          <div className="admin-image">
            <img src={image} />
          </div>
          <div className="admin-details">
            <span>Name</span>
            <div className="admin-title">{name}</div>
            <div className="admin-metas">
              <div className="meta-item">
                <div className="meta-content">
                  <div className="meta-label">E-mail</div>
                  <div className="meta-data">{email}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {(createdDate || updatedDate) && (
          <div className="admin-item-row border-t">
            {/* <div className="admin-info">
            
              <div className="info">
                <div className="info-label">Email Verified</div>
                <div className="info-data">
                  {email_verified === true
                    ? "YES"
                    : email_verified === false
                    ? "NO"
                    : ""}
                </div>
              </div>
              
            </div> */}
            <div className="admin-info">
              {createdDate && (
                <div className="info">
                  <div className="info-label">Created Date</div>
                  <div className="info-data">{createdDate}</div>
                </div>
              )}
              {updatedDate && (
                <div className="info">
                  <div className="info-label">Last Updated</div>
                  <div className="info-data">{updatedDate}</div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Confirm
        icon={"fa-regular fa-xmark"}
        iconColorClass={"bg-danger"}
        title={"Delete"}
        text={"Are you really want to delete this?"}
        isOpen={deleteModal}
        confirmClose={() => setDeleteModal(false)}
        confirmSubmit={() => {
          deleteProduct.mutate({ id: adminId });
        }}
      />
    </>
  );
};

export default AdminItem;
